import ExcelGrid from "components/Custom/ExcelGrid";
import { LABELS } from "common/lables";
import React, { useEffect, useRef, useState } from "react";
import Loader from "components/Custom/Loader";

const ItemSummary = (props: any) => {
  const { salesInvoiceRef } = props;
  const summaryRef: any = useRef();
  const [summaryRows, setSummaryRows] = useState<any[]>(null);
  let total = 0;
  const summaryCols = [
    {
      key: "item",
      type: "text",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.ITEM_NAME,
      width: "40%",
    },
    {
      key: "totalStrip",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.TOTAL_STRIP_PACKET,
      width: "20%",
      renderSum: true,
    },
    {
      key: "Bag",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.BAG_CARTON,
      width: "20%",
      renderSum: true,
    },
    {
      key: "stripPacket",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.STRIP_PACKET,
      width: "20%",
      renderSum: true,
    },
  ];
  useEffect(() => {
    getSummaryRows();
  }, []);

  const getSummaryRows = () => {
    const rowsItem = salesInvoiceRef.getSelectedRows();
    console.log("rowsItem", rowsItem);
    let listItem = [];
    for (let j = 0; j < rowsItem.length; j++) {
      total += Number(Number(rowsItem[j].total).toFixed(2));
      rowsItem[j].items &&
        rowsItem[j].items.map((q) => {
          return listItem.push({
            item: q.productName,
            totalStrip: q.soldSku,
            Bag: "0",
            stripPacket: "0",
          });
        });
    }
    setSummaryRows(listItem);
  };

  return (
    <>
      {summaryRows != null && (
        <ExcelGrid
          id={"summaryGrid"}
          childRef={summaryRef}
          cols={summaryCols}
          rows={summaryRows}
          noTotalRows={true}
        />
      )}
    </>
  );
};
export default ItemSummary;
